<template>
  <div class="termsandconditions content">
    <div v-html="markdownContent"></div>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  computed: {
    markdownContent () {
      let content = `
## Terms & Conditions
      `
      return marked(content)
    }
  }
}
</script>
